export default __webpack_public_path__ + "static/media/IPReturn.ad44861a.svg";